import type { Tag, TagCategory } from '~/ducks/asset-tags/data/Tag';

interface Payload {
  tagCategory: TagCategory;
  tag: Tag;
  assets: AssetId[];
}

export const createBatches = (payload: Payload, BATCH_SIZE: number) => {
  if (BATCH_SIZE <= 0) {
    throw new RangeError('Batch size has to be over 0');
  }

  return payload.assets.reduce<Payload[]>((acc, assetId, index) => {
    const batchNr = Math.floor(index / BATCH_SIZE);
    acc[batchNr] = acc[batchNr] || { ...payload, assets: [] };
    acc[batchNr].assets.push(assetId);

    return acc;
  }, []);
};
